import {
	AccessRouteForm,
	AdditionalInfoForm,
	BasicInfoForm,
	CareerInformationForm,
	CorporationForm,
	ETCInfoForm,
	EducationForm,
	FCRegistrationForm,
	FamilyRelationshipForm,
	GStarClubForm,
	InsuranceExperienceForm,
	PersonalInfoForm,
	ProfessionalQualificationForm,
	TaxAccountantInfoForm
} from "@/features/tax-accountant";
import {
	ITaxAccountantResModel,
	TaxAccountantRegisterV2Request,
	TaxAccountantResModel,
	useCreateTaxAccountant,
	useGetEmployeeMe
} from "@/shared/api";
import { vars } from "@/shared/lib";
import { DEFAULT_TAX_ACCOUNTANT_REGISTER } from "@/shared/model";
import { Button, Center, Column, Row, Toast } from "@/shared/ui";
import { DeepKeys, standardSchemaValidator, useForm } from "@tanstack/react-form";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import dayjs from "dayjs";
import { useState } from "react";

export const Route = createFileRoute("/(auth)/_layout/tax-accountant/register")({
	component: TaxAccountantScreen
});

const VIEW_TYPE = "CREATE";

function TaxAccountantScreen() {
	const navigate = useNavigate();
	const { mutate, reset: resetCreate } = useCreateTaxAccountant();
	const { data: meData } = useGetEmployeeMe();

	const isLeader = meData.authority === "DIRECTOR" || meData.authority === "TEAM_LEADER";

	const [savedValues, setSavedValues] = useState<ITaxAccountantResModel>({
		...DEFAULT_TAX_ACCOUNTANT_REGISTER,
		basicInformation: {
			...DEFAULT_TAX_ACCOUNTANT_REGISTER.basicInformation,
			managers: !isLeader ? [
				{
					managerId: meData.id,
					name: meData.name,
					startDate: dayjs().format("YYYY-MM-DD")
				}
			] : []
		}
	});

	const form = useForm({
		defaultValues: savedValues,

		asyncAlways: true,
		asyncDebounceMs: 700,
		validatorAdapter: standardSchemaValidator(),
		validators: {
			onChangeAsync: TaxAccountantResModel.model,
			onChangeAsyncDebounceMs: 700,
			onBlurAsyncDebounceMs: 700
			// onMount: () => {
			// 	return {
			// 		fields: {
			// 			"basicInformation.name": "basicInformation.name",
			// 			"basicInformation.nameBeforeModified": "basicInformation.nameBeforeModified",
			// 			"basicInformation.companyId": "basicInformation.companyId",
			// 			"basicInformation.managers": "basicInformation.managers",
			// 			"basicInformation.status": "basicInformation.status",
			// 			certificate: "certificate",
			// 			"corporationInformation.coordinate.latitude": "corporationInformation.coordinate.latitude",
			// 			"corporationInformation.coordinate.longitude": "corporationInformation.coordinate.latitude",
			// 			"corporationInformation.coordinate": "corporationInformation.coordinate",
			// 			"corporationInformation.detail": "corporationInformation.detail",
			// 			"corporationInformation.employeeCount": "corporationInformation.employeeCount",
			// 			"corporationInformation.familyInformations": "corporationInformation.familyInformations",
			// 			"corporationInformation.familyWorked": "corporationInformation.familyWorked",
			// 			"corporationInformation.fax": "corporationInformation.fax",
			// 			"corporationInformation.id": "corporationInformation.id",
			// 			"corporationInformation.jibunAddress": "corporationInformation.jibunAddress",
			// 			"corporationInformation.name": "corporationInformation.name",
			// 			"corporationInformation.roadNameAddress": "corporationInformation.roadNameAddress",
			// 			"corporationInformation.telephone": "corporationInformation.telephone",
			// 			"corporationInformation.type": "corporationInformation.type",
			// 			"insuranceExperienceInformation.ga": "insuranceExperienceInformation.ga",
			// 			"insuranceExperienceInformation.indemnity": "insuranceExperienceInformation.indemnity",
			// 			"insuranceExperienceInformation.life": "insuranceExperienceInformation.life",
			// 			"accessRouteInformation.inPersonManager.id": "accessRouteInformation.inPersonManager.id",
			// 			gStarClubs: "gStarClubs",
			// 			"accessRouteInformation.inPersonManager.name": "accessRouteInformation.inPersonManager.name",
			// 			"accessRouteInformation.inPersonManager": "accessRouteInformation.inPersonManager",
			// 			"accessRouteInformation.referer": "accessRouteInformation.referer",
			// 			"familyInformation.familyMemberInformations": "familyInformation.familyMemberInformations",
			// 			"familyInformation.familyMemberInformations[0].name": "familyInformation.familyMemberInformations[0].name",
			// 			"familyInformation.familyMemberInformations[0].job": "familyInformation.familyMemberInformations[0].job",
			// 			"familyInformation.familyMemberInformations[1].name": "familyInformation.familyMemberInformations[1].name",
			// 			"familyInformation.familyMemberInformations[1].job": "familyInformation.familyMemberInformations[1].job",
			// 			"familyInformation.maritalStatus": "familyInformation.maritalStatus",
			// 			"personalInformation.birthday": "personalInformation.birthday",
			// 			"personalInformation.birthdayType": "personalInformation.birthdayType",
			// 			"personalInformation.birthplace": "personalInformation.birthplace",
			// 			"personalInformation.bloodType": "personalInformation.bloodType",
			// 			"personalInformation.email": "personalInformation.email",
			// 			"personalInformation.gender": "personalInformation.gender",
			// 			"personalInformation.genderCode": "personalInformation.genderCode",
			// 			"personalInformation.golfHandicaps": "personalInformation.golfHandicaps",
			// 			"personalInformation.golfPreference": "personalInformation.golfPreference",
			// 			"personalInformation.hobbies": "personalInformation.hobbies",
			// 			"personalInformation.hobby": "personalInformation.hobby",
			// 			"personalInformation.phone": "personalInformation.phone",
			// 			"personalInformation.realBirthday": "personalInformation.realBirthday",
			// 			"personalInformation.religion": "personalInformation.religion",
			// 			"personalInformation.twelveZodiacAnimal": "personalInformation.twelveZodiacAnimal",
			// 			"additionalInformation.closeTaxAccountant": "additionalInformation.closeTaxAccountant",
			// 			"additionalInformation.numberOfCorporationCustomer": "additionalInformation.numberOfCorporationCustomer",
			// 			"additionalInformation.numberOfTaxBookCustomer": "additionalInformation.numberOfTaxBookCustomer",
			// 			"additionalInformation.ratioOfCorporation": "additionalInformation.ratioOfCorporation",
			// 			"additionalInformation.": "additionalInformation.closeTaxAccountant",
			// 			"fcRegistrationInformations[0].fcCertificate": "fcRegistrationInformations[0].fcCertificate",
			// 			"fcRegistrationInformations[0].certificateReason": "fcRegistrationInformations[0].certificateReason",
			// 			"fcRegistrationInformations[0].registeredBy": "fcRegistrationInformations[0].registeredBy",
			// 			"fcRegistrationInformations[0].registeredDate": "fcRegistrationInformations[0].registeredDate",
			// 			"fcRegistrationInformations[0].resignedDate": "fcRegistrationInformations[0].resignedDate",
			// 			"etcInformation.carBrand": "etcInformation.carBrand",
			// 			"etcInformation.contract": "etcInformation.contract",
			// 			"etcInformation.familyInsurancePlannerInformations": "etcInformation.familyInsurancePlannerInformations",
			// 			"etcInformation.familyTaxAccountantInformations": "etcInformation.familyTaxAccountantInformations",
			// 			"etcInformation.otherBusiness": "etcInformation.otherBusiness",
			// 			"etcInformation.sns1": "etcInformation.sns1",
			// 			"etcInformation.sns2": "etcInformation.sns2",
			// 			"etcInformation.sns3": "etcInformation.sns3",
			// 			"etcInformation.assetSize": "etcInformation.assetSize",
			// 			"careerInformations[0].workHistory": "careerInformations[0].workHistory",
			// 			"careerInformations[1].workHistory": "careerInformations[1].workHistory",
			// 			"careerInformations[2].workHistory": "careerInformations[2].workHistory",
			// 			"educationInformations[0].educationDetail": "educationInformations[0].educationDetail",
			// 			"educationInformations[1].educationDetail": "educationInformations[1].educationDetail",
			// 			"educationInformations[2].educationDetail": "educationInformations[2].educationDetail",
			// 			"registrationInformation.closedDate": "registrationInformation.closedDate",
			// 			"registrationInformation.deathDate": "registrationInformation.deathDate",
			// 			"registrationInformation.numberOfExam": "registrationInformation.numberOfExam",
			// 			"registrationInformation.registeredDate": "registrationInformation.registeredDate",
			// 			"registrationInformation.registrationNumber": "registrationInformation.registrationNumber",
			// 			manualUpdateDate: "manualUpdateDate"
			// 		}
			// 	};
			// }
		},
		onSubmit: async ({ value, formApi }) => {
			const filteredMaritalStatus = value.familyInformation?.maritalStatus ?? "UNKNOWN";
			const filteredFamilyInfo =
				value.familyInformation?.familyMemberInformations.filter((familyMemberInformation) =>
					familyMemberInformation.relationship === "SPOUSE"
						? familyMemberInformation.job && familyMemberInformation.name
						: true
				) ?? [];

			const registerValue = await TaxAccountantRegisterV2Request.schema.safeParseAsync({
				...value,
				basicInformation: {
					...value.basicInformation,
					manager: value.basicInformation.managers.length > 0 ? value.basicInformation.managers[0] : null
				},
				gStarClubs: value.gStarClubs,
				corporationInformation: {
					...value.corporationInformation,
					id: null,
					type: value.corporationInformation?.type ?? "UNKNOWN",
					name: value.corporationInformation?.name ?? "",
					detail: value.corporationInformation?.detail ?? "",
					telephone: value.corporationInformation?.telephone ?? "",
					fax: value.corporationInformation?.fax ?? "",
					jibunAddress: value.corporationInformation?.jibunAddress ?? "",
					roadNameAddress: value.corporationInformation?.roadNameAddress ?? "",
					employeeCount: value.corporationInformation?.employeeCount ?? 0,
					coordinate: {
						longitude: value.corporationInformation?.coordinate?.longitude ?? -1,
						latitude: value.corporationInformation?.coordinate?.latitude ?? -1
					},
					familyWorked: value.corporationInformation?.familyWorked ?? null,
					familyInformations: value.corporationInformation?.familyWorked === true ? value?.corporationInformation?.familyInformations.filter(info => info.name) : []
				},
				familyInformation: { maritalStatus: filteredMaritalStatus, familyMemberInformations: filteredFamilyInfo }
			});

			if (registerValue.success) {
				mutate(registerValue.data, {
					onSuccess: () => {
						Toast.info("세무사 등록 신청되었습니다");

						navigate({
							to: "/search/simple-search",
							replace: true
						});
					},
					onError: (error) => {
						if (Array.isArray(error.data)) {
							for (const data of error.data) {
								const fieldName = data.field as DeepKeys<ITaxAccountantResModel>;
								formApi.setFieldMeta(fieldName, (prevData) => {
									return {
										...prevData,
										errorMap: { onChange: data.reason }
									};
								});

								Toast.error(`${data.reason}`);
							}
						}

						formApi.reset();
						resetCreate();
						setSavedValues(value);
					}
				});
			} else {
				console.error("REGISTER PARSE ERROR ===>", registerValue.error);
			}
		}
	});

	return (
		<Column fullWidth>
			<Row
				fullWidth
				style={{
					justifyContent: "flex-start",
					alignItems: "flex-start",
					gap: vars.size[48]
				}}
			>
				<Column
					fullWidth
					style={{
						// minWidth: "400px",
						justifyContent: "flex-start",
						alignItems: "flex-start",
						gap: vars.size[32]
					}}
				>
					<BasicInfoForm form={form} viewType={VIEW_TYPE} />
					<ProfessionalQualificationForm form={form} viewType={VIEW_TYPE} />
					<CorporationForm form={form} viewType={VIEW_TYPE} />
					<InsuranceExperienceForm form={form} viewType={VIEW_TYPE} />
					<AccessRouteForm form={form} viewType={VIEW_TYPE} />
					<FamilyRelationshipForm form={form} viewType={VIEW_TYPE} />
					<GStarClubForm viewType={VIEW_TYPE} form={form} />
				</Column>

				<Column
					fullWidth
					style={{
						// minWidth: "400px",
						justifyContent: "flex-start",
						alignItems: "flex-start",
						gap: vars.size[32]
					}}
				>
					<PersonalInfoForm form={form} viewType={VIEW_TYPE} />
					<AdditionalInfoForm form={form} viewType={VIEW_TYPE} />
					<ETCInfoForm form={form} viewType={VIEW_TYPE} />
				</Column>

				<Column
					fullWidth
					style={{
						// minWidth: "400px",
						justifyContent: "flex-start",
						alignItems: "flex-start",
						gap: vars.size[32]
					}}
				>
					<CareerInformationForm form={form} viewType={VIEW_TYPE} />
					<EducationForm form={form} viewType={VIEW_TYPE} />
					<TaxAccountantInfoForm form={form} viewType={VIEW_TYPE} />
					<FCRegistrationForm form={form} viewType={VIEW_TYPE} />
				</Column>
			</Row>

			<Center fullWidth style={{ paddingBlock: vars.size[32], paddingInline: vars.size[16] }}>
				<Button
					size="medium"
					type="submit"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						form.handleSubmit();
					}}
				>
					{"등록하기"}
				</Button>
			</Center>
		</Column>
	);
}
